import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { MssoBypassEffects } from './msso-bypass.effects';
import { MssoBypassContainerComponent } from './msso-bypass.container';
import { CardModule } from 'atlas-card';
import { ButtonModule } from 'atlas-button';

export const COMPONENTS = [
  MssoBypassContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    // // MercerOSModule,
    CardModule,
    ButtonModule,
    EffectsModule.forFeature([MssoBypassEffects])
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class MssoBypassModule {
}
